import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { ActiontrackerConstantsService } from './actiontracker-constants.service';
import { ConstantsService } from '../../shared/services/constants.service';
import { BaseService } from '../../shared/services/base.service';

@Injectable()
export class ActiontrackerService {
  public updatedVerifierData: any;
  public updatedPartyData: any;
  public updatedOwnerData: any;
  public updatedActionData: any;
  public updateSourceActionData: any;
  currentActionTrackerRequestId: string;
  constructor(private dataService: DataService, private baseService: BaseService) { }
  public setActionTrackerIds(allActionIds) {
    this.baseService.setItemInSession('actionIds', JSON.stringify(allActionIds));
  }
  public getAllActionTrackerIds() {
    return JSON.parse(this.baseService.getItemFromSession('actionIds'));
  }
  public setSourceActionData(data) {
    this.updateSourceActionData = data;
  }
  public getSourceActionData() {
    return this.updateSourceActionData;
  }
  public setUpdatedData(data, actionType) {
    switch (actionType) {
      case 'ActionParty':
        this.updatedPartyData = data;
        break;
      case 'ActionOwner':
        this.updatedOwnerData = data;
        break;
      case 'ActionVerifier':
        this.updatedVerifierData = data;
        break;
      case 'UpdateAction':
        this.updatedActionData = data;
        break;

    }
  }
  public getUpdatedData(actionType) {
    switch (actionType) {
      case 'ActionParty':
        return this.updatedPartyData;
      case 'ActionOwner':
        return this.updatedOwnerData;
      case 'ActionVerifier':
        return this.updatedVerifierData;
      case 'UpdateAction':
        return this.updatedActionData;
    }
  }
  // service call to get all the actions by process id
  getActionsByFilters(model, callbackMethod) {
    const requestData = model;
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionsByFilters, requestData)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // service call to submit the action details
  submitActionDetails(model, callbackMethod) {
    const requestData = model;
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.SubmitActionDetails, requestData)
      .subscribe(response => {
        callbackMethod(response);
      });
  }


  // service call to get user details by email or user id
  getUserDetails(model, callbackMethod) {
    this.dataService.post(ConstantsService.APIURL.Common.GetUserByEmailOrId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Uploaded documents
  getUploadedDocumentById(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetUploadedDocumentById, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Status
  getStatusByProcessId(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetStatusByProcessId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Process
  getProcess(callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetProcess)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get action details by ActionId
  getActionDetailsById(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionDetailsById, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Observation data of particular id
  getObservationRequest(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetObservationRequest, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Action data for verifier dashboard
  getActionForVerifierDashboard(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionForVerifierDashboard, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Action data for action owner dashboard
  getActionForActionOwnerDashboard(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionForActionOwnerDashboard, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get Action Reports for hse dashboard
  getAllReportsForUser(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetAllReportsForUser, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Get All Actions for action  dashboard
  getAllActionsForUser(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetAllActionsForUser, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  //Get action type for actions
  getActionTypeForAction(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionTypeForAction, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  // Get Action data for Action Party dashboard
  getActionForActionPartyDashboard(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionForActionPartyDashboard, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get observation type by company id
  getObservationTypeByCompanyId(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetObservationTypeByCompanyId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get observation for Action owner
  getObservationDetailForActionOwner(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetObservationDetailForActionOwner, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Assign Action to action part and action verifier
  assignActionToActionOwner(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.ActionAssignByActionOwner, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get action details get model
  getActionGetModelById(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionGetModelById, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // submit verifier action
  submitVerifierAction(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.SubmitVerifierAction, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // Assign Action to action part and action verifier
  reassignActionToActionParty(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.ReassignActionToActionParty, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // close action
  closeAction(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.CloseAction, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get action details for risk request by action id
  getActionDetailsForRiskRequestByActionId(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionDetailsForRiskRequestByActionId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  // get action details for risk request by action id
  getActionDetailsForSourcConfigByActionId(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetActionDetailsForSourceConfigRequestByActionId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to Get All Source Configuration Details based on company id.
     * @param model - Model contain api request
     * @param response - response of request.
     */
  getSourceConfigurationDetails(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.getSourceConfigurationDetails, model)
      .subscribe(response => {
        callbackMethod(response.Result);
      });
  }

  // service call to get all the employee's name whose initial entered
  getSearchResultsForUsers(model, callbackMethod) {
    const requestData = model;
    this.dataService.post(ConstantsService.APIURL.Common.GetUsersOnSearch, requestData)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
  * Function to raise source configuration for action
  * @param Model - Model to send data to api
  * @param callbackMethod - return the response
  */
  raiseSourceConfigurationAction(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.raiseSourceConfigurationAction, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
  * Function to get all actions for HSE
  * @param Model - Model to send data to api
  * @param callbackMethod - return the response
  */
  getHseAdvisorActions(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.getHseAdvisorActions, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
     * Function to get all actions for HSE
     * @param Model - Model to send data to api
     * @param callbackMethod - return the response
     */
  exportToExcelHseAdvisorActions(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.exportToExcelHseAdvisorActions, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  /**
  * Function to save pdf to DMS
  * @param Model - Model to send data to api
  * @param callbackMethod - return the response
  */
  savePDF(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.SavePDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getSourceConfigurationDetailsById(model, callbackMethod) {
    this.dataService.post(ActiontrackerConstantsService.ActiontrackerURL.GetSourceConfigDetailsById, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  public setcurrentActionTrackerRequestId(actionId) {
    this.currentActionTrackerRequestId = actionId;
  }
  public getcurrentActionTrackerRequestId() {
    return this.currentActionTrackerRequestId;
  }

}
